export default __webpack_public_path__ + "static/media/en-medical-card.aa11b622.png";